// extracted by mini-css-extract-plugin
export var currencyInput = "_mv-1";
export var currencySymbol = "_mv-0";